import { IMAGES_PATH } from '@telialt/assets/src/constants';
import { RadioImageProps } from '@telialt/common-radio-image-group/src/RadioImageGroup';
import {
    Bank,
    CheckoutPaymentBank,
    CheckoutPaymentMethod,
    CheckoutPaymentMethods,
} from '@telialt/models/src/EshopModel';
import { TeliaSegment } from '@telialt/utils/src/segment';

export const getBankImagePath = (bankId: `${CheckoutPaymentBank}`): string => {
    const bankImageBasePath: string = `${IMAGES_PATH}/bank/`;

    return {
        [CheckoutPaymentBank.Seb]: `${bankImageBasePath}seb.svg`,
        [CheckoutPaymentBank.Siauliu]: `${bankImageBasePath}siauliu.svg`,
        [CheckoutPaymentBank.Swedbank]: `${bankImageBasePath}swedbank.svg`,
        [CheckoutPaymentBank.Luminor]: `${bankImageBasePath}dnbnord.svg`,
    }[bankId];
};

export const toBankOption = ({ id }: Bank): RadioImageProps => ({
    imageUrl: getBankImagePath(id),
    imageAlt: id,
    id,
});

export const getCheckoutPaymentBank = (bankName: string): CheckoutPaymentBank | undefined =>
    Object.values(CheckoutPaymentBank).find((bank) => bankName === bank);

export const isPaymentMethodDescriptionVisible = (
    segment: TeliaSegment,
    paymentMethod: CheckoutPaymentMethod,
): boolean =>
    segment === TeliaSegment.B2b &&
    [CheckoutPaymentMethods.Bank, CheckoutPaymentMethods.PostponedPayment].includes(
        paymentMethod as CheckoutPaymentMethods,
    );
